import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-locked-field-tooltip",
  templateUrl: "./locked-field-tooltip.component.html",
  styleUrls: ["./locked-field-tooltip.component.scss"]
})
export class LockedFieldTooltipComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() messageKey: string = "common.nameFieldLockedTooltip";
  @Input() link: string;

  message = "";

  private langChangeSub: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.buildMessage();
    this.langChangeSub = this.translate.onLangChange.subscribe(() =>
      this.buildMessage()
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.link || changes.messageKey) {
      this.buildMessage();
    }
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  private buildMessage(): void {
    const raw = this.translate.instant(this.messageKey) || "";
    this.message = raw.replace(/{{\s*link\s*}}/g, this.link || "");
  }
}
